import { apiUrl_ } from '../config'
import myAxios from '../myAxios'
import {
  ISchoolThemeLayoutOptions,
  ISchoolThemeLayouts,
  ISchoolThemeOptions,
} from '../../components/SchoolTemplates/ISchoolTemplates'

const myBaseUrlDomain = apiUrl_

export const GenerateSchoolPreview = (
  schoolId: string,
  themeId: string,
  themeOptions: ISchoolThemeOptions,
  themeLayouts: ISchoolThemeLayoutOptions,
) => {
  const body = {
    theme_layouts: themeLayouts,
    theme_options: themeOptions,
    school_id: schoolId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-theme-v2/v2/theme_preview/${themeId}`,
    body,
  )
}

export const GetThemeDetails = (themeId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-theme-v2/v2/theme_details/${themeId}`,
  )
}

export const AddNewThemeDetails = (themeDetails: {
  github_url: string
  name: string
  description: string
}) => {
  const body = {
    github_url: themeDetails.github_url,
    name: themeDetails.name,
    description: themeDetails.description,
  }

  return myAxios.post(
    `${myBaseUrlDomain}/school-theme-v2/v2/theme_details`,
    body,
  )
}

export const UpdateNewThemeDetails = (
  themeId: string,
  themeDetails: {
    name: string
    description: string
    version: number
  },
) => {
  const body = {
    name: themeDetails.name,
    description: themeDetails.description,
    version: themeDetails.version,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-theme-v2/v2/theme_details/${themeId}`,
    body,
  )
}

export const GetAllSchoolThemes = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-theme-v2/v2/all_school_themes/school_id/${schoolId}`,
  )
}

export const GetAllPublicThemes = () => {
  return myAxios.get(`${myBaseUrlDomain}/school-theme-v2/v2/all_public_themes`)
}

export const GetAllUserUploadedThemes = () => {
  return myAxios.get(`${myBaseUrlDomain}/school-theme-v2/v2/all_user_theme`)
}

export const SyncThemeFromGithub = (themeId: string) => {
  const body = {
    theme_id: themeId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-theme-v2/v2/school/sync_theme`,
    body,
  )
}

export const GetActiveSchoolTheme = (schoolId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-theme-v2/v2/active/school_id/${schoolId}/?school_id=${schoolId}`,
  )
}

export const GetSchoolThemeDetails = (schoolId: string, themeId: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-theme-v2/v2/school-theme/${themeId}/school_id/${schoolId}/?school_id=${schoolId}`,
  )
}

export const GetActiveSchoolThemeFromUrl = (schoolUrl: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/active/school-theme-v2/v2/school_url/${schoolUrl}`,
  )
}

export const GetSchoolThemeFromHostname = (hostname: string) => {
  return myAxios.get(
    `${myBaseUrlDomain}/school-theme-v2/v2/active/hostname/${hostname}`,
  )
}

export const AddThemeToSchool = (opts: {
  schoolId: string
  themeId: string
  themeOptions?: ISchoolThemeOptions
  themeLayouts?: ISchoolThemeLayouts[]
}) => {
  const { schoolId, themeId, themeOptions, themeLayouts } = opts
  const body = {
    school_id: schoolId,
    theme_id: themeId,
    theme_options: themeOptions,
    theme_layouts: themeLayouts,
  }
  return myAxios.post(
    `${myBaseUrlDomain}/school-theme-v2/v2/school/theme`,
    body,
  )
}

export const ActivateSchoolTheme = (opts: {
  schoolId: string
  themeId: string
}) => {
  const body = {
    theme_id: opts.themeId,
    school_id: opts.schoolId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-theme-v2/v2/school/activate_theme`,
    body,
  )
}

export const DeactivateSchoolTheme = (opts: {
  schoolId: string
  themeId: string
}) => {
  const body = {
    theme_id: opts.themeId,
    school_id: opts.schoolId,
  }
  return myAxios.put(
    `${myBaseUrlDomain}/school-theme-v2/v2/school/deactivate_theme`,
    body,
  )
}
